import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { SupervisedUserCircleOutlined } from '@material-ui/icons';

const HeaderModules = props => {

    const { icon, title, margin } = props;
    const classes = useStyles(margin);

    return (
        <div className={classes.container}>
            { icon }
            <h3 className={classes.title}>{ title }</h3>
        </div>
    );
}

HeaderModules.defaultProps = {
    icon: <SupervisedUserCircleOutlined />,
    title: 'Title',
    margin: 0
}

const useStyles = makeStyles((margin) => ({
    container: {
        background: '#fff', 
        height: 80, 
        borderRadius: 6, 
        display: 'flex', 
        alignItems: 'center', 
        paddingLeft: 20,
        //marginLeft: margin => margin,
        //marginRight: margin => margin,
        marginTop: margin => margin,
        marginBottom: margin => margin
    },
    title: {
        fontFamily: 'Roboto', 
        marginLeft: 10, 
        marginRight: 20, 
        color: 'rgba(0,0,0,.7)'
    }
}));

export default HeaderModules;